import { Size, size } from './size'

export const sizePropertyValue = (value: number | Size) => {
  return (typeof value === 'string' ? size[value] : value) + 'px'
}
